import packageJson from '../../package.json';

const environmentStage = 'test';

export const environment = {
    production: false,
    environmentName: environmentStage,
    fsDocumentDirectory: 'amagno.dev',
    deepLinkPrefix: 'amagno-dev://',
    electronCustomProtocol: 'amagno-dev',
    inProgressDirectory: 'desktop',
    apiEnvironment: 'dev',
    apiUrlParts: [
        'amagnome',
        'api',
        'internal'
    ],
    stage: 'test',
    servers: [
        'test',
        'dev'
    ],
    version: `${packageJson.version}-${environmentStage}`,
    sentry: true,
    mockServers: [
        {
            url: 'http://localhost:9000/AmagnoMe/api',
            displayUrl: 'localhost:9000',
            name: 'Mock-Server'
        },
        {
            url: 'http://10.0.2.2:9000/AmagnoMe/api',
            displayUrl: '10.0.2.2:9000',
            name: 'Mock-Server (Android-Emulator)'
        },
        {
            url: 'http://:9000/AmagnoMe/api', // LAN-IP des Rechners eintragen, z. B. http://192.168.0.10:9000/AmagnoMe/api
            displayUrl: ':9000', // LAN-IP des Rechners eintragen, z. B. 192.168.0.10:9000
            name: 'Mock-Server (Gerät)'
        }
    ],
    maskPathsInLogging: false,
    sendTelemetryData: false,
};
